export const WeekProofStrip = ({ summary }) => {
  if (!summary) return null;
  const wc = summary.weight_change_kg;
  const stats = [
    { label: "Commitments kept", value: `${summary.commitments_kept}`, sub: `/${summary.commitments_possible}`, testid: "proof-commitments" },
    { label: "Full days built", value: summary.full_days, testid: "proof-full-days" },
    { label: "Workouts logged", value: summary.workouts_logged, testid: "proof-workouts" },
    { label: "Meals logged", value: summary.meals_logged, testid: "proof-meals" },
    { label: "Proof written", value: summary.proof_entries, testid: "proof-entries" },
    { label: "Weight change", value: wc === null || wc === undefined ? "—" : `${wc > 0 ? "+" : ""}${wc}`, sub: wc === null || wc === undefined ? "" : " kg", testid: "proof-weight" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 stagger" data-testid="week-proof-strip">
      {stats.map((s) => (
        <div key={s.label} className="card" data-testid={s.testid}>
          <p className="eyebrow">{s.label}</p>
          <p className="font-display font-black text-2xl md:text-3xl mt-2">
            {s.value}<span className="text-zinc-600 text-sm">{s.sub}</span>
          </p>
        </div>
      ))}
    </div>
  );
};
